import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import confirm from "../../../shared/modal/confirm";
import ScrollIntoView from "../../../shared/scroll-into-view/scroll-into-view";
import Loader from "./../../../shared/loader";
import {
  clearRedirect,
  deleteProp,
  fetchProp,
  updateProp,
  uploadImagesAndSaveProp,
  changePropToSetDressing,
  changePropToCostume,
  fetchAllCharacters,
  fetchAllBackgroundCharacters,
  fetchUrlPreview
} from "./ducks/actions";
import Form from "./form";

function EditProp(props) {
  const filmId = props.filmId || props.match.params.filmId;
  const propId = props.propId || props.match.params.propId;

  const {
    fetchProp,
    updateProp,
    changePropToSetDressing,
    uploadImagesAndSaveProp,
    changePropToCostume,
    deleteProp,
    clearRedirect,
    loadingProp,
    prop,
    errors,
    embedded,
    fetchAllCharacters,
    fetchAllBackgroundCharacters,
    allCharacters,
    allBackgroundCharacters,
    onCloseForm,
    fetchUrlPreview,
    loadingUrlPreview
  } = props;

  const invalidIds = ["add", "overview"];

  useEffect(() => {
    if (invalidIds.indexOf(propId) === -1) {
      fetchProp(filmId, propId);
      fetchAllCharacters(filmId);
      fetchAllBackgroundCharacters(filmId);
    }
  }, [filmId, propId]);

  useEffect(() => {
    if (prop && allCharacters) {
      prop.characters = [];
      prop.characterIds?.forEach(characterId => {
        const character = allCharacters.find((c) => c.id === characterId);
        if (character) {
          prop.characters.push({ value: characterId, label: character.name });
        }
      });
    }
  }, [prop, allCharacters]);

  useEffect(() => {
    if (prop && allBackgroundCharacters) {
      prop.backgroundCharacters = [];
      prop.backgroundCharacterIds?.forEach(backgroundCharacterId => {
        const backgroundCharacter = allBackgroundCharacters.find((c) => c.id === backgroundCharacterId);
        if (backgroundCharacter) {
          prop.backgroundCharacters.push({ value: backgroundCharacterId, label: backgroundCharacter.name })
        }
      });
    }
  }, [prop, allBackgroundCharacters]);

  if (!embedded && props.redirect) {
    if (props.redirect.to === "list") {
      clearRedirect();
      const url = `/films/${filmId}/props/overview`;
      return <Redirect to={url} />;
    } else if (props.redirect.to === "set-dressing") {
      props.clearRedirect();
      const url = `/films/${filmId}/set-dressings/${props.redirect.id}/edit`;
      return <Redirect to={url} />;
    } else if (props.redirect.to === "prop") {
      props.clearRedirect();
      const url = `/films/${filmId}/props/${props.redirect.id}/edit`;
      return <Redirect to={url} />;
    }
  }

  if (invalidIds.indexOf(propId) > -1) {
    return null;
  }

  function renderLoading() {
    return <Loader />;
  }

  function renderProp(prop) {
    return (
      <ScrollIntoView
        className="blade-content widest"
        path="/films/:filmId/props/:propId/edit"
        loading={loadingProp}>
        <Form
          errors={errors}
          mode="edit"
          filmId={filmId}
          propId={prop.id}
          initialValues={prop}
          loading={loadingProp}
          onSubmit={onUpdateProp}
          handleDelete={onDeleteProp}
          onChangePropToSetDressing={onChangePropToSetDressing}
          onChangePropToCostume={onChangePropToCostume}
          reduxFormValues={props.reduxFormValues}
          acquisitionMethodEnum={props.acquisitionMethodEnum}
          allCharacters={allCharacters}
          allBackgroundCharacters={allBackgroundCharacters}
          onCloseForm={onCloseForm}
          fetchUrlPreview={fetchUrlPreview}
          loadingUrlPreview={loadingUrlPreview}
          {...props}
        />
      </ScrollIntoView>
    );
  }

  function onUpdateProp(prop) {
    prop.characterIds = prop.characters?.map((x) => x.value || x);
    prop.backgroundCharacterIds = prop.backgroundCharacters?.map((x) => x.value || x);
    const files = prop.pictures || [];

    if ((files && files.length) > 0 || (prop.images && prop.images.length > 0)) {
      uploadImagesAndSaveProp(prop, files, false, filmId);
    } else {
      updateProp(filmId, prop);
    }
  }

  function onDeleteProp(prop) {
    confirm(() => deleteProp(filmId, prop), prop?.name);
  }

  const onChangePropToSetDressing = (prop) => {
    confirm(() => changePropToSetDressing(filmId, prop), null, `Are you sure you want to change ${prop.name} into a Set Dressing?`, "Change Prop");
  };

  const onChangePropToCostume = (prop) => {
    confirm(() => changePropToCostume(filmId, prop), null, `Are you sure you want to change ${prop.name} into a Costume?`, "Change Prop");
  };

  return prop && !loadingProp ? renderProp(prop) : renderLoading();
}

function mapStateToProps(state) {
  const { propsState, commonState } = state;
  return {
    prop: propsState.prop,
    errors: propsState.errors,
    redirect: propsState.redirect,
    acquisitionMethodEnum: commonState.acquisitionMethod,
    allCharacters: propsState.characters,
    allBackgroundCharacters: propsState.backgroundCharacters,
    loadingUrlPreview: propsState.loadingUrlPreview,
  };
}

export default connect(mapStateToProps, {
  fetchProp,
  updateProp,
  deleteProp,
  clearRedirect,
  uploadImagesAndSaveProp,
  changePropToSetDressing,
  changePropToCostume,
  fetchAllCharacters,
  fetchAllBackgroundCharacters,
  fetchUrlPreview
})(EditProp);
